export default __webpack_public_path__ + "static/media/dark-mode.fca61e4d.svg";